import { useState,useEffect } from "react";
import {
  Settings,
  Users,
  Briefcase,
  Bell,
  BarChart2,
  DollarSign,
  FolderKanban,
  LogOut
} from "lucide-react";
import axios from "axios";
import logoEmpresa from "../assets/logo_moroni2.png";
import API from "../api";

const Sidebar = ({ onSelect, onLogout, rolUsuario }) => {
  const [adminAbierto, setAdminAbierto] = useState(false);

  const rol = String(rolUsuario ?? "").trim().toLowerCase();

  const tienePermiso = (vista) => {
    if (!rol) return true;
    if (rol === "administrador") return true;
    if (rol === "gerente") return vista !== "Administración";
    if (rol === "funcional") return vista === "Comercial";
    return false;
  };

  const manejarClick = (seccion) => {
    if (seccion === "Administración") {
      setAdminAbierto(!adminAbierto);
      return;
    } else {
      setAdminAbierto(false);
    }
    onSelect(seccion);
  };

  const [pendientes, setPendientes] = useState(0);

  useEffect(() => {
    const obtenerSolicitudesPendientes = async () => {
      try {
        const res = await axios.get(`${API}/solicitudes_rrhh`);
        const soloPendientes = res.data.filter(s => s.Estado === "Pendiente");
        setPendientes(soloPendientes.length);
      } catch (err) {
        console.error("Error al cargar notificaciones:", err);
      }
    };

    obtenerSolicitudesPendientes();
  }, []);

  return (
    <>
      <button
        className="btn btn-outline-light d-md-none position-fixed top-0 start-0 m-3"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasSidebar"
        aria-controls="offcanvasSidebar"
      >
        &#9776;
      </button>

      {/* SIDEBAR ESCRITORIO */}
      <div
        className="d-none d-md-flex flex-column justify-between bg-dark text-light position-fixed top-0 start-0 h-100 p-3"
        style={{ width: "240px", paddingTop: "56px" }}
      >
        <div>
          <img src={logoEmpresa} alt="Logo Empresa" style={{ height: "90px", objectFit: "contain", backgroundColor: "transparent" }} />
          <ul className="nav nav-pills flex-column">

            {/* ✅ MI PERFIL - SIEMPRE VISIBLE */}
            <li className="nav-item mb-2">
              <button
                onClick={() => manejarClick("Mi Perfil")}
                className="btn btn-dark text-start w-100 d-flex align-items-center gap-2"
              >
                <Users size={18} />
                <span>Mi Perfil</span>
              </button>
            </li>

            {/* ✅ ADMINISTRACIÓN (si tiene permiso) */}
            {tienePermiso("Administración") && (
              <li className="nav-item mb-2">
                <button
                  onClick={() => manejarClick("Administración")}
                  className="btn btn-dark text-start w-100 d-flex justify-content-between align-items-center"
                >
                  <div className="d-flex align-items-center gap-2">
                    <Settings size={18} />
                    <span>Administración</span>
                  </div>
                  <span className="small text-white-50">{adminAbierto ? "▲" : "▼"}</span>
                </button>
                {adminAbierto && (
                  <ul className="list-group bg-light text-dark mt-2 rounded shadow-sm">
                    <li className="border-top"></li>
                    <li
                      onClick={() => onSelect("Gestión de Usuarios")}
                      className="list-group-item list-group-item-action d-flex align-items-center gap-2"
                      style={{ cursor: "pointer" }}
                    >
                      <Users size={18} />
                      <span>Gestión de Usuarios</span>
                    </li>
                    <li className="border-top"></li>
                    <li
                      onClick={() => onSelect("RRHH")}
                      className="list-group-item list-group-item-action d-flex align-items-center gap-2"
                      style={{ cursor: "pointer" }}
                    >
                      <Briefcase size={18} />
                      <span>RRHH</span>
                    </li>
                    <li className="border-top"></li>
                  </ul>
                )}
              </li>
            )}

            {tienePermiso("Comercial") && (
              <li className="nav-item mb-1">
                <button
                  onClick={() => manejarClick("Comercial")}
                  className="btn btn-dark text-start w-100 d-flex align-items-center gap-2"
                >
                  <BarChart2 size={18} />
                  <span>Comercial</span>
                </button>
              </li>
            )}

            {tienePermiso("Finanzas") && (
              <li className="nav-item mb-1">
                <button
                  onClick={() => manejarClick("Finanzas")}
                  className="btn btn-dark text-start w-100 d-flex align-items-center gap-2"
                >
                  <DollarSign size={18} />
                  <span>Finanzas</span>
                </button>
              </li>
            )}

            {tienePermiso("Proyectos") && (
              <li className="nav-item mb-1">
                <button
                  onClick={() => manejarClick("Proyectos")}
                  className="btn btn-dark text-start w-100 d-flex align-items-center gap-2"
                >
                  <FolderKanban size={18} />
                  <span>Proyectos</span>
                </button>
              </li>
            )}
          </ul>
        </div>

        <div className="mt-4">
          <button
            onClick={onLogout}
            className="btn btn-outline-danger w-100 d-flex align-items-center gap-2"
          >
            <LogOut size={18} />
            <span>Cerrar sesión</span>
          </button>
        </div>
      </div>

      {/* SIDEBAR MÓVIL */}
      <div
        className="offcanvas offcanvas-start bg-dark text-light"
        tabIndex="-1"
        id="offcanvasSidebar"
        aria-labelledby="offcanvasSidebarLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasSidebarLabel">Menú</h5>
          <button
            type="button"
            className="btn-close btn-close-white"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body p-3 d-flex flex-column justify-between h-100">
          <ul className="nav nav-pills flex-column">

            {/* ✅ MI PERFIL - SIEMPRE VISIBLE */}
            <li className="nav-item mb-2">
              <button
                onClick={() => manejarClick("Mi Perfil")}
                className="btn btn-dark text-start w-100 d-flex align-items-center gap-2"
                data-bs-dismiss="offcanvas"
              >
                <Users size={18} />
                <span>Mi Perfil</span>
              </button>
            </li>

            {/* ✅ ADMINISTRACIÓN (si tiene permiso) */}
            {tienePermiso("Administración") && (
              <li className="nav-item mb-2">
                <button
                  onClick={() => manejarClick("Administración")}
                  className="btn btn-dark text-start w-100 d-flex justify-content-between align-items-center"
                  data-bs-dismiss="offcanvas"
                >
                  <div className="d-flex align-items-center gap-2">
                    <Settings size={18} />
                    <span>Administración</span>
                  </div>
                  <span className="small text-white-50">{adminAbierto ? "▲" : "▼"}</span>
                </button>
                {adminAbierto && (
                  <ul className="list-group bg-light text-dark mt-2 rounded shadow-sm">
                    <li
                      onClick={() => onSelect("Notificaciones")}
                      className="list-group-item list-group-item-action d-flex align-items-center gap-2"
                      style={{ cursor: "pointer" }}
                      data-bs-dismiss="offcanvas"
                    >
                      <Bell size={18} />
                      <span>Notificaciones</span>
                    </li>
                    <li className="border-top"></li>
                    <li
                      onClick={() => onSelect("Gestión de Usuarios")}
                      className="list-group-item list-group-item-action d-flex align-items-center gap-2"
                      style={{ cursor: "pointer" }}
                      data-bs-dismiss="offcanvas"
                    >
                      <Users size={18} />
                      <span>Gestión de Usuarios</span>
                    </li>
                    <li className="border-top"></li>
                    <li
                      onClick={() => onSelect("RRHH")}
                      className="list-group-item list-group-item-action d-flex align-items-center gap-2"
                      style={{ cursor: "pointer" }}
                      data-bs-dismiss="offcanvas"
                    >
                      <Briefcase size={18} />
                      <span>RRHH</span>
                    </li>
                    <li className="border-top"></li>
                  </ul>
                )}
              </li>
            )}

            {tienePermiso("Comercial") && (
              <li className="nav-item mb-1">
                <button
                  onClick={() => manejarClick("Comercial")}
                  className="btn btn-dark text-start w-100 d-flex align-items-center gap-2"
                  data-bs-dismiss="offcanvas"
                >
                  <BarChart2 size={18} />
                  <span>Comercial</span>
                </button>
              </li>
            )}

            {tienePermiso("Finanzas") && (
              <li className="nav-item mb-1">
                <button
                  onClick={() => manejarClick("Finanzas")}
                  className="btn btn-dark text-start w-100 d-flex align-items-center gap-2"
                  data-bs-dismiss="offcanvas"
                >
                  <DollarSign size={18} />
                  <span>Finanzas</span>
                </button>
              </li>
            )}

            {tienePermiso("Proyectos") && (
              <li className="nav-item mb-1">
                <button
                  onClick={() => manejarClick("Proyectos")}
                  className="btn btn-dark text-start w-100 d-flex align-items-center gap-2"
                  data-bs-dismiss="offcanvas"
                >
                  <FolderKanban size={18} />
                  <span>Proyectos</span>
                </button>
              </li>
            )}
          </ul>

          <div className="mt-3">
            <button
              onClick={() => {
                document.querySelector(".offcanvas")?.classList.remove("show");
                document.body.classList.remove("offcanvas-backdrop");
                onLogout();
              }}
              className="btn btn-outline-danger w-100 d-flex align-items-center gap-2"
            >
              <LogOut size={18} />
              <span>Cerrar sesión</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
